import { sortBy, uniq } from "lodash";

export default function sortHashtags(hashtags: string[] | null | undefined) {
  if (!hashtags?.length) return null;
  return uniq(sortBy(hashtags));
}
